import { DURATION_OF_USE, DURATION_OF_USE_BY_LABEL, DurationOfUseType } from '../../../constants';

export const toDurationKey = (value: string): DurationOfUseType | undefined => {
  if (value in DURATION_OF_USE) return value as DurationOfUseType;
  if (value in DURATION_OF_USE_BY_LABEL) return DURATION_OF_USE_BY_LABEL[value];
  return undefined;
};
